import { render, staticRenderFns } from "./DeductionNoticeBtn.vue?vue&type=template&id=1e2b7735&scoped=true&"
import script from "./DeductionNoticeBtn.vue?vue&type=script&lang=js&"
export * from "./DeductionNoticeBtn.vue?vue&type=script&lang=js&"
import style0 from "./DeductionNoticeBtn.vue?vue&type=style&index=0&id=1e2b7735&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2b7735",
  null
  
)

export default component.exports